import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "flex-fill" }
const _hoisted_3 = { class: "fw-semibold fs-13" }
const _hoisted_4 = { class: "text-muted fs-12" }
const _hoisted_5 = { class: "d-flex flex-wrap gap-2 mt-2 fs-12" }
const _hoisted_6 = { class: "badge bg-primary-transparent" }
const _hoisted_7 = { class: "badge bg-secondary-transparent" }
const _hoisted_8 = {
  key: 0,
  class: "badge bg-success-transparent"
}
const _hoisted_9 = { class: "d-flex justify-content-between align-items-end mt-2" }
const _hoisted_10 = { class: "fw-semibold" }
const _hoisted_11 = { class: "text-muted fs-12" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "predict-map-popup-card" }
const _hoisted_14 = {
  key: 0,
  class: "badge bg-primary mb-2"
}
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = { class: "flex-fill" }
const _hoisted_17 = { class: "fw-semibold fs-13" }
const _hoisted_18 = { class: "text-muted fs-12" }
const _hoisted_19 = { class: "mt-2" }
const _hoisted_20 = { class: "fw-semibold" }
const _hoisted_21 = { class: "text-muted fs-12" }
const _hoisted_22 = {
  key: 0,
  class: "predict-map-popup-card bg-light fs-12 text-muted py-2"
}
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = { class: "flex-fill" }
const _hoisted_25 = { class: "fw-semibold fs-13" }
const _hoisted_26 = { class: "text-muted fs-12" }
const _hoisted_27 = { class: "d-flex flex-wrap gap-2 mt-2 fs-12" }
const _hoisted_28 = { class: "badge bg-primary-transparent" }
const _hoisted_29 = {
  key: 0,
  class: "badge bg-success-transparent"
}
const _hoisted_30 = { class: "d-flex justify-content-between align-items-end mt-2" }
const _hoisted_31 = { class: "fw-semibold" }
const _hoisted_32 = { class: "text-muted fs-12" }
const _hoisted_33 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LControlLayers = _resolveComponent("LControlLayers")!
  const _component_MapyCzBasicLayer = _resolveComponent("MapyCzBasicLayer")!
  const _component_MapyCzOrthoPhotoLayer = _resolveComponent("MapyCzOrthoPhotoLayer")!
  const _component_LPopup = _resolveComponent("LPopup")!
  const _component_LMarker = _resolveComponent("LMarker")!
  const _component_LMap = _resolveComponent("LMap")!

  return (_openBlock(), _createBlock(_component_LMap, {
    zoom: _ctx.zoom,
    center: _ctx.center,
    options: {zoomSnap: 0.25},
    class: "flex-grow-1",
    onReady: _ctx.onMapReady,
    ref: "container"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LControlLayers, { position: "topright" }),
      _createVNode(_component_MapyCzBasicLayer),
      _createVNode(_component_MapyCzOrthoPhotoLayer, { visible: false }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comparedMarkers, (marker) => {
        return (_openBlock(), _createBlock(_component_LMarker, {
          key: marker.key,
          icon: _ctx.createComparedIcon(marker),
          "lat-lng": marker.coordinates,
          "z-index-offset": 0
        }, {
          default: _withCtx(() => [
            _createVNode(_component_LPopup, {
              options: {maxHeight: _ctx.maxPopupHeight, minWidth: 260, className: 'predict-map-popup'}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(marker.estates, (estate, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "predict-map-popup-card"
                  }, [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("span", {
                        class: _normalizeClass(['avatar', 'avatar-sm', 'estate-avatar', 'me-2', 'estate-avatar-' + estate.estateType])
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(['fas', estate.icon])
                        }, null, 2)
                      ], 2),
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, _toDisplayString(estate.typeName) + ", " + _toDisplayString(estate.area) + " m²", 1),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(estate.locationName), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, "shoda " + _toDisplayString(estate.matchPercent) + " %", 1),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formatDistance(estate.distanceMeters)), 1),
                      (estate.priceFromPurchaseContract)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "kupní smlouva"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(estate.price), 1),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(estate.pricePerMeter) + " / m²", 1)
                      ]),
                      (estate.detailUrl !== null)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: "javascript:",
                            class: "btn btn-sm btn-primary-light",
                            onClick: _withModifiers(($event: any) => (_ctx.openDetail(estate.detailUrl)), ["prevent"])
                          }, "Detail", 8, _hoisted_12))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["options"])
          ]),
          _: 2
        }, 1032, ["icon", "lat-lng"]))
      }), 128)),
      (_ctx.mainEstate !== null)
        ? (_openBlock(), _createBlock(_component_LMarker, {
            key: 0,
            icon: _ctx.mainIcon,
            "lat-lng": _ctx.mainEstate.coordinates,
            "z-index-offset": 1000
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LPopup, {
                options: {maxHeight: _ctx.maxPopupHeight, minWidth: 260, className: 'predict-map-popup'}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    (_ctx.mainLabel !== null)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.mainLabel), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", {
                        class: _normalizeClass(['avatar', 'avatar-sm', 'estate-avatar', 'me-2', 'estate-avatar-' + _ctx.mainEstate.estateType])
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(['fas', _ctx.mainEstate.icon])
                        }, null, 2)
                      ], 2),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.mainEstate.typeName) + ", " + _toDisplayString(_ctx.mainEstate.area) + " m²", 1),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.mainEstate.locationName), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.mainEstate.value), 1),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.mainEstate.pricePerMeter) + " / m²", 1)
                    ])
                  ]),
                  (_ctx.estatesAtMainSpot.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Na stejném místě " + _toDisplayString(_ctx.estatesAtMainSpot.length === 1 ? 'je srovnávaná nemovitost' : 'jsou srovnávané nemovitosti') + ": ", 1))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estatesAtMainSpot, (estate, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "predict-map-popup-card"
                    }, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", {
                          class: _normalizeClass(['avatar', 'avatar-sm', 'estate-avatar', 'me-2', 'estate-avatar-' + estate.estateType])
                        }, [
                          _createElementVNode("i", {
                            class: _normalizeClass(['fas', estate.icon])
                          }, null, 2)
                        ], 2),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, _toDisplayString(estate.typeName) + ", " + _toDisplayString(estate.area) + " m²", 1),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(estate.locationName), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("span", _hoisted_28, "shoda " + _toDisplayString(estate.matchPercent) + " %", 1),
                        (estate.priceFromPurchaseContract)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, "kupní smlouva"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_31, _toDisplayString(estate.price), 1),
                          _createElementVNode("div", _hoisted_32, _toDisplayString(estate.pricePerMeter) + " / m²", 1)
                        ]),
                        (estate.detailUrl !== null)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: "javascript:",
                              class: "btn btn-sm btn-primary-light",
                              onClick: _withModifiers(($event: any) => (_ctx.openDetail(estate.detailUrl)), ["prevent"])
                            }, "Detail", 8, _hoisted_33))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["options"])
            ]),
            _: 1
          }, 8, ["icon", "lat-lng"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["zoom", "center", "onReady"]))
}